import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { PageLayout } from '@hero/layouts';

export default function SettingsLayout() {
  const { t } = useTranslation();

  return (
    <PageLayout
      header={{
        title: t('userDetails'),
        backButton: true
      }}
    >
      <Outlet />
    </PageLayout>
  );
}
